import { useReplicacheQueryV2 } from '~/hooks-data/use-replicache-query'
import { useCR } from './use-merge-diff'
import { useRepoReplicache } from '~/hooks-data/use-repo-replicache'
import { invariant } from '@epic-web/invariant'
import { Branch } from '@basehub/data/replicache/index'
import { commitMutators } from '@basehub/data/replicache/mutators/repo-space/commit/mutators'
import { beginPerfReport } from '@basehub/utils/perf/index'
import { calculateCommitLineage } from '@basehub/data/commit/index'

export const useCRMetadata = ({ branch }: { branch: Branch | null }) => {
  const crId = branch?.contentRequestIds?.[0] ?? null
  const { cr, baseBranch } = useCR({ crId })
  const replicache = useRepoReplicache().data?.replicache

  return useReplicacheQueryV2({
    key: [
      'commit-lineage',
      cr?.baseBranchId,
      cr?.headBranchId,
      branch?.headCommitId,
      baseBranch?.headCommitId,
    ],
    replicache,
    fetcher: async (tx) => {
      const perfReport = beginPerfReport('useCRMetadata-fetcher')
      invariant(branch, 'not enabled')

      const result = await calculateCommitLineage({
        sourceCommitId: branch.headCommitId,
        headCommitId: baseBranch?.headCommitId ?? null,
        getCommit: async (id: string) => {
          const commit = await commitMutators.getCommit(tx, id)
          return commit ?? null
        },
      })

      perfReport.end(false)
      return result
    },
    enabled: !!cr && !!branch && !!baseBranch,
    keepPreviousData: true,
  })
}
